<script setup lang="ts">
import { SignatureDocumentFieldType } from '@/store/enums';
import {ref, onMounted, Ref} from 'vue';
import {usePortalIntakeStore} from "@/store/PortalIntakeModule";

const props = defineProps<{
    documentIndex: number,
    fieldIndex: number
}>();

const value = ref('');

const intakeStore = usePortalIntakeStore();
const setDocumentField = (docIndex: number, fieldIndex: number, field: {type: SignatureDocumentFieldType, value: Ref<string|undefined>}) =>
    intakeStore.dispatch('setDocumentField', {docIndex, fieldIndex, field});

onMounted(() =>
    setDocumentField(props.documentIndex, props.fieldIndex, {type: SignatureDocumentFieldType.RelatedPersonName, value})
);
</script>

<template>
    <div>
        <p-input-text
            v-model="value"
            placeholder="Related Person Name"
            :val="value"
        />
        <span class="signature-form-data signature-form-related-person">
            {{ value }}
        </span>
    </div>
</template>
